// src/services/emailService.js
import emailjs from '@emailjs/browser';

// Pegar valores do .env
const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;
const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;

// Verificar se carregou corretamente
console.log('📧 EmailJS Config:', {
  publicKey: PUBLIC_KEY ? '✅' : '❌',
  serviceId: SERVICE_ID ? '✅' : '❌',
  templateId: TEMPLATE_ID ? '✅' : '❌'
});

// Inicializar EmailJS (uma vez)
emailjs.init(PUBLIC_KEY);

/**
 * 📧 Enviar email de recuperação de senha
 * @param {string} userEmail - Email do usuário
 * @param {string} resetToken - Token único para reset
 * @param {string} userName - Nome do usuário
 */
export const sendResetPasswordEmail = async (userEmail, resetToken, userName = 'Cliente') => {
  
  // Validações básicas
  if (!userEmail) {
    throw new Error('Email é obrigatório');
  }
  
  if (!resetToken) {
    throw new Error('Token é obrigatório');
  }
  
  // ✅ LINHA CORRIGIDA: Agora usa o domínio de produção
  const resetLink = `https://app.ilhaleads.com.br/reset-password/${resetToken}`;
  
  // Parâmetros que vão para sua template
  const templateParams = {
    to_email: userEmail,
    user_name: userName,
    reset_link: resetLink,
    company_name: 'Ilha Leads Imóveis',
    expires_in: '1 hora',
    support_email: 'suporte@ilhaleads.com',
    current_year: new Date().getFullYear().toString()
  };

  console.log('📧 Enviando email com parâmetros:', {
    to: userEmail,
    name: userName,
    link: resetLink.substring(0, 50) + '...'
  });

  try {
    // Enviar email via EmailJS
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      templateParams
    );

    console.log('✅ Email enviado com sucesso:', response.status, response.text);
    
    return {
      success: true,
      message: 'Email enviado com sucesso',
      data: response
    };

  } catch (error) {
    console.error('❌ Erro detalhado ao enviar email:', error);
    
    // Mensagens amigáveis baseadas no erro
    let errorMessage = 'Erro ao enviar email.';
    
    if (error.text?.includes('invalid')) {
      errorMessage = 'Credenciais inválidas. Verifique Service ID e Template ID.';
    } else if (error.text?.includes('limit')) {
      errorMessage = 'Limite de emails atingido. Tente novamente amanhã.';
    } else if (error.text?.includes('network')) {
      errorMessage = 'Erro de rede. Verifique sua conexão.';
    }
    
    return {
      success: false,
      message: errorMessage,
      error: error.text || error.message
    };
  }
};

// Serviço completo de email
export const emailService = {
  sendResetPassword: sendResetPasswordEmail,
  
  // Para uso futuro
  sendWelcomeEmail: async (userEmail, userName) => {
    console.log('📧 Welcome email para:', userEmail);
    // Implementar depois
  },
  
  sendNotification: async (userEmail, subject, message) => {
    console.log('📧 Notificação para:', userEmail);
    // Implementar depois
  }
};

export default emailService;